import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

type Balance = { month: { cost_usd: number; calls: number } };

/**
 * Petit badge cliquable : affiche le coût IA du mois en cours.
 * Cliquable → /admin/ia (admin only) ou non cliquable pour les autres.
 */
export default function AiUsageBadge({ adminLink }: { adminLink: boolean }) {
  const [cost, setCost] = useState<number | null>(null);
  const [calls, setCalls] = useState<number>(0);

  useEffect(() => {
    let cancel = false;
    async function load() {
      try {
        const r = await api.get<Balance>('/ai/usage/balance');
        if (cancel) return;
        setCost(r.month?.cost_usd ?? 0);
        setCalls(r.month?.calls ?? 0);
      } catch {
        if (!cancel) setCost(null);
      }
    }
    load();
    // Refresh toutes les 60 s
    const t = setInterval(load, 60_000);
    return () => {
      cancel = true;
      clearInterval(t);
    };
  }, []);

  if (cost === null) return null;

  const label = `IA : ${cost.toFixed(2)} USD ce mois (${calls} appels)`;
  const styleBox: React.CSSProperties = {
    fontSize: 11,
    padding: '6px 10px',
    background: 'var(--c-nav)',
    border: '1px solid var(--c-border)',
    borderRadius: 8,
    color: 'var(--c-text)',
    textDecoration: 'none',
    display: 'inline-block',
  };

  if (adminLink) {
    return (
      <Link to="/admin/ia/consommation" style={styleBox} title="Voir la consommation détaillée">
        {label}
      </Link>
    );
  }
  return <div style={styleBox}>{label}</div>;
}
